/** @file The world rounding grid: half an authored pixel per axis, camera-free (design 21.4, 22.1). */
import type { Profile } from '@zilo/pose3d-format/types/profile';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/**
 * Per-axis step in units: `1 / (2 px)` with `px` the profile's authored pixels per unit on each axis,
 * `profile.tilePx = [across, depth, height]` (22.1: a 24 x 16 tile steps 1/48 across and 1/32 deep and high), absent =
 * `pixelsPerUnit` on every axis (pixel16: 1/32); never the camera-projected size (21.4 supersedes 18.7).
 */
export function worldGridOf(profile: Profile): Vec3 {
  const ppu = profile.pixelsPerUnit;
  const [x, y, z] = profile.tilePx ?? [ppu, ppu, ppu];
  return [1 / (2 * x), 1 / (2 * y), 1 / (2 * z)];
}
